/**
 * 利用闭包实现防抖
 * @param func
 * @param delay
 * @returns {(function(): void)|*}
 */
function debounce(func, delay) {
    let timerId
    return function() {
        const context = this
        const args = arguments

        clearTimeout(timerId)

        timerId = setTimeout(function() {
            func.apply(context, args)
        }, delay)
    }
}

export default debounce


// WEBPACK FOOTER //
// ./src/utils/debounce.js